const EXTENSION_LABELS = {
  pdf: 'PDF',
  doc: 'DOC',
  docx: 'DOCX',
  xls: 'XLS',
  xlsx: 'XLSX',
  ppt: 'PPT',
  pptx: 'PPTX',
  txt: 'TXT',
  csv: 'CSV',
  zip: 'ZIP',
};

export function getFileExtension(fileName = '') {
  const parts = `${fileName}`.trim().split('.');
  if (parts.length < 2) return '';
  return parts.pop().toLowerCase();
}

export function getFileTypeLabel(fileName = '') {
  const ext = getFileExtension(fileName);
  if (!ext) return 'Document';
  return EXTENSION_LABELS[ext] || ext.toUpperCase();
}

export function getFileDisplayName(fileName = 'Document') {
  const trimmed = `${fileName}`.trim();
  return trimmed || 'Document';
}
